"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _moduleRegistry = _interopRequireDefault(require("./module-registry"));

var _tagAppender = require("./tag-appender");

var _assign = _interopRequireDefault(require("lodash/assign"));

var _ReactModuleContainerErrors = require("./ReactModuleContainerErrors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var BaseLazyComponent = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(BaseLazyComponent, _React$Component);

  function BaseLazyComponent(props, manifest) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.manifest = manifest;
    return _this;
  }

  var _proto = BaseLazyComponent.prototype;

  _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
    var _this2 = this;

    _moduleRegistry["default"].notifyListeners('reactModuleContainer.componentStartLoading', this.manifest.component);

    var prepare = this.manifest.prepare ? function () {
      return _this2.manifest.prepare();
    } : function () {
      return undefined;
    };
    var filesAppenderPromise = (0, _tagAppender.filesAppender)(this.manifest.files, this.manifest.crossorigin).then(prepare);
    var resolvePromise = this.manifest.resolve ? this.manifest.resolve() : Promise.resolve({});
    this.resourceLoader = Promise.all([resolvePromise, filesAppenderPromise]).then(function (_ref) {
      var resolvedData = _ref[0];
      _this2.resolvedData = resolvedData;

      _moduleRegistry["default"].notifyListeners('reactModuleContainer.componentReady', _this2.manifest.component);
    })["catch"](function (err) {
      _moduleRegistry["default"].notifyListeners('reactModuleContainer.error', new _ReactModuleContainerErrors.LazyComponentLoadingError(_this2.manifest.component, err));
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.manifest.unloadStylesOnDestroy !== false) {
      (0, _tagAppender.unloadStyles)(document, this.manifest.files);
    }

    _moduleRegistry["default"].notifyListeners('reactModuleContainer.componentWillUnmount', this.manifest.component);
  };

  _createClass(BaseLazyComponent, [{
    key: "mergedProps",
    get: function get() {
      return (0, _assign["default"])({}, this.props, this.resolvedData);
    }
  }]);

  return BaseLazyComponent;
}(_react["default"].Component);

exports["default"] = BaseLazyComponent;